module.exports = __webpack_public_path__ + "static/img/main.ae7274be.jpg";